import ExpressEnergy from './views/expressEnergy.c';
export default ExpressEnergy;
